import classNames from 'classnames';
import React from 'react';

export class Picture extends React.Component {
  state = {
    showCopyright: false
  }

  showInfo = (e) => {
    this.setState({ showCopyright: true });
  }

  hideInfo = (e) => {
    this.setState({ showCopyright: false });
  }

  get className () {
    return classNames({
      'picture': true,
      'picture--copyright': this.state.showCopyright
    })
  }

  render = () => (
    <picture className={this.className}>
      <img src={this.props.src || this.props.image?.file?.url} />
      <span className="picture__info" onClick={this.showInfo}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke="white"/>
          <path d="M12.0038 7.272C11.6798 7.272 11.4158 7.176 11.2118 6.984C11.0198 6.78 10.9238 6.516 10.9238 6.192C10.9238 5.868 11.0198 5.61 11.2118 5.418C11.4158 5.214 11.6798 5.112 12.0038 5.112C12.3278 5.112 12.5858 5.214 12.7778 5.418C12.9818 5.61 13.0838 5.868 13.0838 6.192C13.0838 6.516 12.9818 6.78 12.7778 6.984C12.5858 7.176 12.3278 7.272 12.0038 7.272ZM12.7238 9V18H11.2838V9H12.7238Z" fill="white"/>
        </svg>
      </span>
      <figcaption className="picture__caption" onClick={this.hideInfo}>{ this.props.image?.title }</figcaption>
    </picture>
  )
}